import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const langCode = window.localStorage.getItem('Language') ?? 'en-US';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: langCode,
    lng: langCode,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      "en-US": {
        translation: {
          "header-programs": "PROGRAMS",
          "header-services": "SERVICES",
          "header-clients": "CLIENTS",
          "header-contact": "CONTACT",
          "hero-head-1": "YOUR ORGANIZATION’S POTENTIAL DEPENDS ON THE",
          "hero-head-2": "PERFORMANCE OF YOUR PEOPLE.",
          "hero-text-1": "Our purpose is to elevate it.",
          "hero-btn": "CONTACT US",
          "purpose-title-1": "OUR PURPOSE",
          "purpose-title-2": "EXPLAINED",
          "purpose-ux-text": "We discover how to visually talk to your teams and create narratives and branding that maximize change.",
          "purpose-learn-title": "LEARNING",
          "purpose-learn-text": "We create tailor-made learning experiences that develop the competencies your people need to succeed at their jobs.",
          "purpose-culture-title": "LEADERSHIP",
          "purpose-culture-text": "We align and coach your most influential decision makers elevating their consciousness as leaders.",
          "purpose-change-title": "PERFORMANCE IMPROVEMENT",
          "purpose-change-text-1": "This intersection is where authentic, sustainable",
          "purpose-change-text-2": "change",
          "purpose-change-text-3": "and",
          "purpose-change-text-4": "cultural transformation",
          "purpose-change-text-5": "occur across all organizational levels.",
          "phases-performance-title": "PERFORMANCE",
          "phases-behavior-title": "BEHAVIOR",
          "phases-learn-title": "LEARNING",
          "phases-learn-text": "& communication",
          "phases-training-title": "TRAINING",
          "phases-training-text": "& campaigns",
          "specialties-title-1-1": "WE IMPROVE PERFORMANCE IN",
          "specialties-title-1-2": "ANY SET OF SKILLS OR INDUSTRY",
          "specialties-title-2-1": "READY TO USE",
          "specialties-title-2-2": "EXPERTISE",
          "specialties-subtitle-1": "Yet, throughout the years, we have gained significant expertise in",
          "specialties-subtitle-2": "four fundamental topics.",
          "specialties-card-title-1": "Leadership Development",
          "specialties-card-text-1": "Build your academy to grow leaders from the front line to executive levels.",
          "specialties-card-title-2": "Safety Culture",
          "specialties-card-text-2": "Empower teams to take charge of their safety and that of their team.",
          "specialties-card-title-3": "Onboarding Programs",
          "specialties-card-text-3": "Delight new team members and shorten their learning curve.",
          "specialties-card-title-4": "Psychological Safety",
          "specialties-card-text-4": "Equip teams with behaviors that foster a trust-based culture.",
          "services-title-1": "TO CREATE YOUR PROGRAM, WE INTEGRATE A STRATEGIC BLEND OF 8 SOLUTIONS THAT",
          "services-title-2": "BREATHES LIFE INTO IT.",
          "services-card-title-1": "FACE-TO-FACE TRAINING",
          "services-card-text-1": "Live, facilitator-led sessions (in person or online) where people learn through active collaboration.",
          "services-card-title-2": "E-LEARNING",
          "services-card-text-2": "Interactive, responsive, and brief online modules packed with high-end multimedia resources.",
          "services-card-title-3": "ON-THE-JOB EXPERIENCES",
          "services-card-text-3": "Self-led activities that allow users to practice what they learned in other formats in their workflow.",
          "services-card-title-4": "TRAIN-THE-TRAINERS",
          "services-card-text-4": "We set facilitators up for success by shifting their paradigm and providing disruptive feedback on their practice.",
          "services-card-title-5": "COMMUNICATION CAMPAIGNS",
          "services-card-text-5": "Inner marketing strategies to keep your programs top of mind.",
          "services-card-title-6": "IMPLEMENTATION SUPPORT",
          "services-card-text-6": "We help your team manage the logistics and program operations.",
          "services-card-title-7": "ALIGNMENT WORKSHOP",
          "services-card-text-7": "We strengthen your executive team’s trust and align them with the organization’s strategy.",
          "services-card-title-8": "EXECUTIVE COACHING",
          "services-card-text-8": "We elevate the consciousness level of your shareholders, executive board, and C-suite.",
          "customers-title-1": "+70",
          "customers-title-2": "CLIENTS AND FRIENDS IN",
          "customers-title-3": "22",
          "customers-title-4": "YEARS",
          "about-us-title-1": "IN LESS THAN",
          "about-us-title-2": "2 MINUTES",
          "about-us-title-3": ", WE WILL TELL YOU",
          "about-us-title-4": "A LOT ABOUT US",
          "about-us-button": "CHECK OUT THIS VIDEO!",
          "contact-us-avatar-title": "Hugo López",
          "contact-us-avatar-subtitle": "CEO and Co-founder",
          "contact-us-avatar-leyend-1": "For things to truly change and improve, we must address the uncomfortable issues with",
          "contact-us-avatar-leyend-2": "love and courage.",
          "contact-us-avatar-text-1": "Coach, mediator, organizational catalyst. Co-founder and CEO of forteorigen, a company that has helped national and international organizations for 22 years, creating experiences that increase and renew the skills and competencies of their people and supporting them in their cultural and personal transformation.",
          "contact-us-avatar-text-2": "Hugo has a degree in Economics and a master’s in Social Psychology. He has facilitated workshops on three continents (in Switzerland, England, Egypt, Brazil, USA, Mexico, and other countries), and coached in all levels of an organization, from shareholders and C-suite leaders to managers, operators, and technicians.",
          "contact-us-avatar-text-3": "He is a musician, singer-songwriter, painter, and lover of nature and his family. Life for him is a constant spiritual search.",
          "contact-us-title-1": "WE HAD TO MEET AT THIS EXACT MOMENT.",
          "contact-us-title-2": "LET’S BEGIN YOUR TRANSFORMATION.",
          "contact-us-title-5": "LET'S BEGIN OUR JOURNEY.",
          "contact-us-subtitle": "Contact us!",
          "contact-us-input-1": "Name:",
          "contact-us-validation-1": "Please enter your name",
          "contact-us-input-2": "Your work email address:",
          "contact-us-validation-2": "Please enter a work email",
          "contact-us-input-3": "Tell us, how can we help you?",
          "contact-us-validation-3": "Please enter a message",
          "contact-us-success": "Looks good!",
          "contact-us-button": "SUBMIT",
          "mail-success-title": "Mail sent",
          "mail-success-text": "The email has been sent successfully.",
          "mail-error-title": "Error sending mail",
          "mail-error-text": "An error occurred while sending the email, please try again.",
          "mail-btn": "OK",
        },
      },
      "es-MX": {
        translation: {
          "header-programs": "PROGRAMAS",
          "header-services": "SERVICIOS",
          "header-clients": "CLIENTES",
          "header-contact": "CONTACTO",
          "hero-head-1": "EL POTENCIAL DE TU ORGANIZACIÓN",
          "hero-head-2": "DEPENDE DEL DESEMPEÑO DE TU GENTE.",
          "hero-text-1": "Nuestro propósito es elevarlo.",
          "hero-btn": "CONTÁCTANOS",
          "purpose-title-1": "NUESTRO PROPÓSITO",
          "purpose-title-2": "EXPLICADO",
          "purpose-ux-text": "Descubrimos cómo hablar visualmente a nuestros usuarios y creamos narrativas atractivas y un branding que maximicen el cambio.",
          "purpose-learn-title": "APRENDIZAJE",
          "purpose-learn-text": "Creamos experiencias de aprendizaje a la medida que desarrollen en los usuarios las competencias necesarias para enfrentar sus retos laborales.",
          "purpose-culture-title": "LIDERAZGO",
          "purpose-culture-text": "Alineamos y damos coaching personal a tus tomadores de decisiones con mayor influencia, elevando su consciencia como líderes.",
          "purpose-change-title": "MEJORA DEL DESEMPEÑO",
          "purpose-change-text-1": "En esta intersección es donde suceden el",
          "purpose-change-text-2": "cambio auténtico y sostenible,",
          "purpose-change-text-3": "",
          "purpose-change-text-4": "y la transformación cultural ",
          "purpose-change-text-5": "en todos los niveles de la organización.",
          "phases-performance-title": "DESEMPEÑO",
          "phases-performance-text-1": "El usuario logra mejores resultados y genera mayor valor al negocio.",
          "phases-performance-text-2": "Esta es la promesa de todas nuestras experiencias de aprendizaje.",
          "phases-behavior-title": "COMPORTAMIENTOS",
          "phases-behavior-text": "El usuario empieza a aplicar lo aprendido en su trabajo.",
          "phases-learn-title": "APRENDIZAJE",
          "phases-learn-text": "y comunicación",
          "phases-training-title": "CAPACITACIÓN",
          "phases-training-text": "y campañas",
          "specialties-title-1-1": "MEJORAMOS EL DESEMPEÑO",
          "specialties-title-1-2": "EN CUALQUIER GRUPO DE COMPETENCIAS E INDUSTRIA.",
          "specialties-title-2-1": "NUESTRAS",
          "specialties-title-2-2": "ESPECIALIDADES",
          "specialties-subtitle-1": "Sin embargo, a través del tiempo hemos adquirido mucha experiencia en",
          "specialties-subtitle-2": "4 temas fundamentales.",
          "specialties-card-title-1": "Desarrollo de liderazgo",
          "specialties-card-text-1": "Construye tu propia academia para desarrollar a tus líderes desde la línea de operación hasta la alta dirección.",
          "specialties-card-title-2": "Cultura de seguridad",
          "specialties-card-text-2": "Empodera a tu gente para que se apropie de su seguridad y la de sus equipos.",
          "specialties-card-title-3": "Onboarding / Inducción",
          "specialties-card-text-3": "Cautiva a tus nuevos ingresos y reduce su curva de aprendizaje.",
          "specialties-card-title-4": "Seguridad psicológica",
          "specialties-card-text-4": "Desarrolla a tus equipos con comportamientos que reflejan una cultura basada en la confianza.",
          "services-title-1": "EN TU PROGRAMA, INTEGRAMOS 8 SOLUCIONES ESTRATÉGICAS QUE",
          "services-title-2": "LE DAN VIDA PROPIA.",
          "services-card-title-1": "ENTRENAMIENTO PRESENCIAL",
          "services-card-text-1": "Experiencias en vivo (virtuales o en persona) donde la gente aprende a través de la colaboración activa.",
          "services-card-title-2": "CÁPSULAS E-LEARNING",
          "services-card-text-2": "Módulos en línea breves, responsivos e interactivos con recursos multimedia de alto impacto.",
          "services-card-title-3": "ACTIVIDADES ON-THE-JOB",
          "services-card-text-3": "Actividades que permiten que el usuario practique en su trabajo lo aprendido en los otros formatos.",
          "services-card-title-4": "TRAIN-THE-TRAINERS",
          "services-card-text-4": "Desafiamos el paradigma de tus facilitadores y les damos retroalimentación aguda.",
          "services-card-title-5": "CAMPAÑAS DE COMUNICACIÓN",
          "services-card-text-5": "Estrategias de marketing interno para que los programas estén en la mente del usuario.",
          "services-card-title-6": "SOPORTE EN LANZAMIENTO",
          "services-card-text-6": "Le ayudamos a tu equipo a gestionar la implementación de tu programa.",
          "services-card-title-7": "TALLER DE ALINEACIÓN",
          "services-card-text-7": "Fortalecemos el nivel de confianza de tu equipo de ejecutivos alineándolo con la estrategia.",
          "services-card-title-8": "COACHING EJECUTIVO",
          "services-card-text-8": "Elevamos el nivel de consciencia de tus accionistas, consejeros y directores.",
          "customers-title-1": "+70",
          "customers-title-2": "CLIENTES Y AMIGOS EN",
          "customers-title-3": "22",
          "customers-title-4": "AÑOS",
          "about-us-title-1": "EN MENOS DE",
          "about-us-title-2": "2 MINUTOS",
          "about-us-title-3": ", TE CONTAMOS",
          "about-us-title-4": "MUCHO SOBRE NOSOTROS",
          "about-us-button": "¡CHECA ESTE VIDEO!",
          "contact-us-avatar-title": "Hugo López",
          "contact-us-avatar-subtitle": "Director General y Co-fundador",
          "contact-us-avatar-leyend-1": "Para que las cosas verdaderamente cambien y mejoren, debemos abordar los temas más difíciles con",
          "contact-us-avatar-leyend-2": "amor y valentía",
          "contact-us-avatar-text-1": "Coach, mediador y catalizador organizacional. CEO y co-fundador de forteorigen, compañía que por 22 años ha ayudado a organizaciones nacionales e internacionales, creando experiencias que incrementan y renuevan las competencias y habilidades de su gente, y apoyándolas en su transformación cultural y personal.",
          "contact-us-avatar-text-2": "Hugo es Licenciado en Economía y tiene una Maestría en Psicología Social. Ha facilitado talleres en 3 continentes (en países como Suiza, Inglaterra, Egipto, Brasil, Estados Unidos, México y muchos otros), con participantes desde Juntas de Consejo, accionistas y equipos directivos, hasta operadores y técnicos. Es músico, cantautor, pintor, amante de la naturaleza y de su familia.",
          "contact-us-avatar-text-3": "La vida para él es una constante búsqueda espiritual.",
          "contact-us-title-1": "NOS TENÍAMOS QUÉ CONOCER JUSTO EN ESTE MOMENTO.",
          "contact-us-title-2": "COMENCEMOS TU TRANSFORMACIÓN.",
          "contact-us-subtitle": "¡Contáctanos!",
          "contact-us-input-1": "Nombre:",
          "contact-us-validation-1": "Por favor ingresa tu nombre",
          "contact-us-input-2": "Dirección de correo de tu trabajo:",
          "contact-us-validation-2": "Por favor ingresa un correo empresarial",
          "contact-us-input-3": "Cuéntanos, ¿cómo te podemos ayudar?",
          "contact-us-validation-3": "Por favor ingresa un mensaje",
          "contact-us-success": "¡Se ve bien!",
          "contact-us-button": "ENVIAR",
          "mail-success-title": "Correo enviado",
          "mail-success-text": "Se ha enviado el correo correctamente.",
          "mail-error-title": "Error al enviar correo",
          "mail-error-text": "Se ha producido un error al enviar el correo, por favor intente nuevamente.",
          "mail-btn": "Aceptar",
        },
      }
    },
  });

export default i18n;